import React from 'react';
import { Form, message } from 'antd';
import ModalDom from '../../../../../components/Modal';
import { CustomRow, CustomCol } from '../../../../../components/Custom';
import { config, postFrom } from '../../../../../axios';
import { handleDeepCopy } from '../../../../../utils';

class Page extends React.Component {
    constructor() {
        super();
        this.initState = {
            loading: false,
            data: {},
        };
        this.state = {
            ...handleDeepCopy(this.initState)
        };
    }

    handleCancel = () => {
        this.id = undefined;
        this.setState({ ...handleDeepCopy(this.initState) }, () => {
            this.props.handleCancel();
        });
    }

    loadPack = ({ id }) => {
        this.setState({ loading: true });
        this.id = id;
        postFrom({ url: config.API_rentcontract_getRentContractById, data: { rentContractId: this.id } }).then(res => {
            this.setState({ loading: false, data: res });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    handleDelete = () => {
        this.setState({ loading: true });
        postFrom({ url: config.API_rentcontract_delete, data: { contractId: this.id } }).then(res => {
            message.success('删除成功');
            this.handleCancel();
            this.props.handleGetList()
        }).catch(err => {
            message.error(err.message || '删除失败');
            this.setState({ loading: false });
        });
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    render() {
        let { visible } = this.props;
        let {
            loading,
            data,
        } = this.state;

        return <ModalDom
            title="删除"
            visible={visible}
            loading={loading}
            onOk={this.handleDelete}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form>
                    <CustomRow>
                        <CustomCol label="小区/楼栋" required={false}>
                            <span className="not-edit">{data.buildingName}</span>
                        </CustomCol>
                        <CustomCol label="房号" required={false}>
                            <span className="not-edit">{data.roomNo}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow>
                        <CustomCol label="姓名" required={false}>
                            <span className="not-edit">{data.customerName}</span>
                        </CustomCol>
                        <CustomCol label="证件号码" required={false}>
                            <span className="not-edit">{data.customerIdNumber}</span>
                        </CustomCol>
                        <CustomCol label="手机号码" required={false}>
                            <span className="not-edit">{data.customerPhone}</span>
                        </CustomCol>
                    </CustomRow>
                </Form>
                <div>
                    请注意：<span style={{ color: 'red', lineHeight: '30px' }}>删除操作不可恢复</span>
                </div>
            </div>
        </ModalDom>
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/RentContract/components/List/Delete/index.js